module.exports = __webpack_public_path__ + "static/media/manual-calculation.cc6c845f.svg";